import React from 'react';
import { Button, Modal } from 'react-bootstrap';
import { useLanguage } from '../../i18n';
import '../../styles/GameRules.css';
import '../../styles/ModalStyles.css';

interface GameRulesProps {
  show?: boolean;
  onHide?: () => void;
}

const GameRules: React.FC<GameRulesProps> = ({ show: propShow, onHide }) => {
  const { t } = useLanguage();
  const [internalShow, setInternalShow] = React.useState(false);

  // 使用props中的show或内部状态
  const show = propShow !== undefined ? propShow : internalShow;

  // 处理关闭事件
  const handleClose = () => {
    if (onHide) {
      onHide();
    } else {
      setInternalShow(false);
    }
  };

  // 处理显示事件（仅在使用内部状态时）
  const handleShow = () => {
    if (propShow === undefined) {
      setInternalShow(true);
    }
  };

  return (
    <>
      {propShow === undefined && (
        <Button variant="kcd" className="kcd-button" onClick={handleShow}>
          {t('gameRules')}
        </Button>
      )}

      <Modal show={show} onHide={handleClose} size="lg" className="kcd-modal">
        <Modal.Header closeButton>
          <Modal.Title>{t('farkleRules')}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <h4>{t('welcomeTitle')}</h4>
          <p>{t('welcomeText')}</p>
          <p>{t('contactText')}</p>

          <h4>{t('gameObjectiveTitle')}</h4>
          <p>{t('gameObjectiveText')}</p>

          <h4>{t('bettingRulesTitle')}</h4>
          <p>{t('bettingRulesText1')}</p>
          <p>{t('bettingRulesText2')}</p>
          <p>{t('bettingRulesText3')}</p>

          <h4>{t('gameFlowTitle')}</h4>
          <p>{t('gameFlowText')}</p>

          <h4>{t('scoringCombosTitle')}</h4>
          <ul>
            <li>{t('scoringSingle1')}</li>
            <li>{t('scoringSingle5')}</li>
            <li>{t('scoringTriple1')}</li>
            <li>{t('scoringTriple2')}</li>
            <li>{t('scoringTriple3')}</li>
            <li>{t('scoringTriple4')}</li>
            <li>{t('scoringTriple5')}</li>
            <li>{t('scoringTriple6')}</li>
            <li>{t('scoringFourOfKind')}</li>
            <li>{t('scoringFiveOfKind')}</li>
            <li>{t('scoringSixOfKind')}</li>
            <li>{t('scoringSmallStraight')}</li>
            <li>{t('scoringLargeStraight')}</li>
            <li>{t('scoringFullStraight')}</li>
          </ul>

          <h4>{t('farkleTitle')}</h4>
          <p>{t('farkleText')}</p>

          <h4>{t('turnEndTitle')}</h4>
          <p>{t('turnEndText')}</p>

          <h4>{t('gameEndTitle')}</h4>
          <p>{t('gameEndText')}</p>
        </Modal.Body>
        <Modal.Footer className="game-rules-footer">
          <Button variant="kcd" className="kcd-button" onClick={handleClose}>
            {t('close')}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default GameRules;
